import React from 'react';
import loader from "../assets/images/loader.gif";
import '../assets/css/Loading.css';

function Loading() {
    return (
        <div className="container loading">
            <img src={loader} alt="Loader"/>
        </div>
    );
}

export default Loading;